// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5da3f6d5","239":"d68594d7","455":"9ecc9050"}[chunkId] + ".chunk.js";
};